import React, { Component }   from 'react'
import { divIcon }            from 'leaflet'
import Listing                from './listing'

const MAP_CENTER_FALLBACK = {
  lat: 41.455721,       // ri - just a random location that has an ocean
  lon: -71.3548304
}

export default class ListingsMap extends Component {

  actions() {
    return this.props.actions || []
  }

  filteredActions() {
    return this.actions().filter((ele) => ele._source !== undefined && ele._source.latitude !== undefined  )
  }

  center() {
    const tmpFilteredActions = this.filteredActions()
    if (tmpFilteredActions.length <= 0) return MAP_CENTER_FALLBACK

    const lats = tmpFilteredActions.filter((obj)=> obj._source.latitude != null).map((obj) => obj._source.latitude)
    const lons = tmpFilteredActions.filter((obj)=> obj._source.longitude != null).map((obj) => obj._source.longitude)
    const latMean = lats.reduce((total, num) => total + num) / lats.length
    const lonMean = lons.reduce((total, num) => total + num) / lons.length

    return [latMean, lonMean]
  }

  render() {
    // Early return if no items in list to render on map
    if (this.filteredActions().length <= 0) {
      return null
    }

    const height = this.props.height || 350
    const mapStyle = 'mapbox/streets-v12'
    const icon = divIcon({
      className:      'sidx-map-listing sidx-map-marker-for-sale',
      html:           '4000',
      iconSize:       [38, 19],
      iconAnchor:     [19, 26],
      tooltipAnchor:  [0, -26],
    })
    const { Map:LeafletMap, TileLayer, ZoomControl, AttributionControl } = require('react-leaflet')

    return (
      <div className='mapContainer'>
        <LeafletMap
          center={this.center()}
          boundsOptions={{ padding: [10, 25] }}
          zoom={10}
          minZoom={4}
          maxZoom={18}
          scrollWheelZoom={false}
          zoomControl={false}
          editable={true}
          attributionControl={false}
          style={{ height }}
          tap={false}
        >

          <TileLayer
            attribution="© <a href='https://www.mapbox.com/about/maps/' target='_blank'>Mapbox</a> © <a href='http://www.openstreetmap.org/copyright' target='_blank'>OpenStreetMap</a> <strong><a href='https://www.mapbox.com/map-feedback/' target='_blank'>Improve this map</a></strong>"
            url={`https://api.mapbox.com/styles/v1/${mapStyle}/tiles/256/{z}/{x}/{y}{r}?access_token=${process.env.MAPBOX_ACCESS_TOKEN}`}/>

          { this.filteredActions().filter(action => action._source.latitude != null && action._source.longitude != null).map((action,i) => <Listing key={i} action={action} icon={icon} />) }

          <ZoomControl position="topleft" />
          <AttributionControl prefix="" />

        </LeafletMap>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/map/index.js